import { render, staticRenderFns } from "./ViewAttachment.vue?vue&type=template&id=f0f5d004"
import script from "./ViewAttachment.vue?vue&type=script&lang=js"
export * from "./ViewAttachment.vue?vue&type=script&lang=js"
import style0 from "./ViewAttachment.vue?vue&type=style&index=0&id=f0f5d004&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VContainer,VDialog,VIcon,VImg})
